const storage = {
    not_configured: 'Provider di archiviazione non configurato.',
    missing_parameter: 'Parametro mancante {{parameter}} per il provider di archiviazione.',
    upload_error: 'Impossibile caricare il file sul provider di archiviazione.',
};
export default Object.freeze(storage);
